var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quota-wrapper" },
    [
      _c("quota-head"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("my-quota", { staticClass: "my-quota __form_border" }),
          _vm._v(" "),
          _c("pledge-tx", { staticClass: "pledge-tx" })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showTeamBtn
        ? _c("div", [
            _c("button", { on: { click: _vm.unlock } }, [
              _vm._v("Withdraw Team Vite")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("list")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }